import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { TableFields } from './tableFields';
import { TableSort } from './tableSort';

export const TableActions = ({
  leftActions,
  rightActions,
  topBanner,
  onColumnAction,
  initialSortBy,
  canSort,
  selectedColumns,
  selectedColumn,
  setSelectedColumns,
  setSelectedColumn,
  tableActions,
  handleSort,
  sortedColumns,
  sx,
  tableRef,
}) => (
  <>
    <Flex
      id="table-actions"
      sx={{
        gap: '8px',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        borderBottom: '1px solid',
        borderColor: 'border.subtle',
        pb: '8px',
        pl: '8px',
        width: '100%',
        '& span': {
          display: ['none', 'none', 'none'],
        },
        ...sx,
      }}
    >
      <Flex
        sx={{
          gap: '8px',
          flexWrap: 'wrap',
        }}
      >
        {leftActions}
        {tableActions}
        <TableFields
          selectedColumns={selectedColumns}
          setSelectedColumns={(item, action, column) => {
            setSelectedColumns(item);
            onColumnAction?.(action, { payload: column });
          }}
          tableRef={tableRef}
        />
        {canSort && (
          <TableSort
            selectedSort={{
              value: initialSortBy,
              label: initialSortBy.desc ? 'Descending' : 'Ascending',
            }}
            setSelectedSort={({ value }) => handleSort(value, selectedColumn.value)}
            columns={sortedColumns.filter((column) => !column.disableSortBy)}
            selectedColumn={selectedColumn}
            setSelectedColumn={(column) => {
              setSelectedColumn(column);
              handleSort(initialSortBy.desc ? 'desc' : 'asc', column.value);
            }}
          />
        )}
      </Flex>
      {rightActions}
    </Flex>
    <Box>{topBanner}</Box>
  </>
);

TableActions.propTypes = {
  leftActions: PropTypes.node,
  rightActions: PropTypes.node,
  topBanner: PropTypes.node,
  onColumnAction: PropTypes.func,
  initialSortBy: PropTypes.object,
  canSort: PropTypes.bool,
  selectedColumns: PropTypes.array,
  selectedColumn: PropTypes.object,
  setSelectedColumns: PropTypes.func,
  setSelectedColumn: PropTypes.func,
  tableActions: PropTypes.node,
  handleSort: PropTypes.func,
  sx: PropTypes.object,
  sortedColumns: PropTypes.array,
  tableRef: PropTypes.object,
};

TableActions.defaultProps = {
  selectedColumns: [],
  selectedColumn: null,
  setSelectedColumns: () => {},
  setSelectedColumn: () => {},
  canSort: false,
  tableActions: null,
  leftActions: null,
  rightActions: null,
  topBanner: null,
  onColumnAction: () => {},
  initialSortBy: null,
  handleSort: () => {},
  sx: {},
  sortedColumns: [],
  tableRef: null,
};

export default TableActions;
